import I18n from "i18n-js";
import { translations } from "./translations";

// Configuración global de traducciones y fallbacks
I18n.translations = translations;
I18n.defaultLocale = "es";
I18n.fallbacks = true;

// Obtener el idioma del atributo lang en <html> con fallback en español
const rawLocale = document.documentElement.getAttribute("lang")?.toLowerCase() || "es";
const baseLocale = rawLocale.split("-")[0] || "es";
I18n.locale = baseLocale;

window.I18n = I18n;

export default I18n;

